import { createElementBlock as l, openBlock as n, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return n(), l("svg", r, e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.969 3.511a2.4 2.4 0 0 0-1.916 0L6.436 5.527a2.39 2.39 0 0 0-1.433 2.19v3.307c-.103 4.197 2.45 7.67 6.21 9.534.495.246 1.05.225 1.48-.038.404-.247.805-.528 1.224-.831a1 1 0 1 1 1.172 1.62c-.43.312-.88.629-1.352.917-1.058.648-2.347.652-3.413.124-4.304-2.134-7.442-6.241-7.32-11.363v-3.27a4.39 4.39 0 0 1 2.631-4.022l4.617-2.018a4.4 4.4 0 0 1 3.519.001l4.604 2.016a4.39 4.39 0 0 1 2.628 4.021V11c0 1.34-.117 2.472-.469 3.549-.354 1.082-.925 2.045-1.75 3.076a1 1 0 1 1-1.561-1.25c.722-.902 1.151-1.656 1.41-2.448.262-.799.37-1.7.37-2.927V7.716a2.39 2.39 0 0 0-1.43-2.189z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: t };
export {
  d as default,
  t as render
};
//# sourceMappingURL=ic_insurance-B1Pw1iD3.js.map
